import { createSelector } from 'reselect';

const selectProjectRegister = (state) => state.project_register;

export const selectProjectRegisterFilters = createSelector(
  selectProjectRegister,
  (root) => root.filters,
);
